module.exports = {
  no_response: 'Keine Antwort vom Server, bitte laden Sie die Seite neu.',
  adobe_api_key_missing: 'Currently, PDFs cannot be shown. Please contact your admin and let them know about this issue (No PDF key for domain)',
  delete_failed: 'The message could not be deleted.',
}
